export function anySelected(targets) {
  for (const checkbox of targets) {
    if (checkbox.checked) {
      return true
    }
  }
  return false
}